import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { createPopper } from "@popperjs/core";
import { PasswordModal } from "src/app/views/admin/users/pass-modal/pass-modal.component";
import { UsersService } from "src/app/views/admin/users/users.service";
import { AlertasSwalService } from "../../../services/alerts.service";

@Component({
  selector: "app-user-dropdown",
  templateUrl: "./user-dropdown.component.html",
})
export class UserDropdownComponent implements AfterViewInit, OnInit {
  dropdownPopoverShow = false;
  @ViewChild("btnDropdownRef", { static: false }) btnDropdownRef: ElementRef;
  @ViewChild("popoverDropdownRef", { static: false })
  popoverDropdownRef: ElementRef;
  initials: string;
  color: string;

  constructor(
    private dialog: MatDialog,
    private service: UsersService,
    private alerts: AlertasSwalService
  ) {}
  ngOnInit(): void {
    this.initials = localStorage.getItem("in") ?? "__";
    this.color = localStorage.getItem("co") ?? "#FFF";
  }

  ngAfterViewInit() {
    createPopper(
      this.btnDropdownRef.nativeElement,
      this.popoverDropdownRef.nativeElement,
      {
        placement: "bottom-start",
      }
    );
  }
  toggleDropdown(event) {
    event.preventDefault();
    if (this.dropdownPopoverShow) {
      this.dropdownPopoverShow = false;
    } else {
      this.dropdownPopoverShow = true;
    }
  }

  logout() {
    localStorage.clear();
    window.location.reload();
  }

  async changePass() {
    const result = await this.dialog
      .open(PasswordModal, {
        panelClass: ["w-full", "lg:w-1/2"],
        data: {
          usuario: "propia",
        },
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.service
        .changePassOwn({
          ...result,
          IdUsuario: null,
        })
        .subscribe(
          (next) => {
            this.alerts.correcta(
              "Actualizado",
              "Accion realizada correctamente"
            );
          },
          (err) => {
            this.alerts.error("error", err.error.Message);
          }
        );
    }
  }

  irArriba() {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }
}
